import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ContactAssigneeIconSvg from './icon-contact-assignee.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <ContactAssigneeIconSvg
            {...validProps}
            color={validProps.color ? validProps.color : '#bf4200'}
        />
    );
}
SvgComponent.iconName = 'contactAssigneeIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ContactAssigneeIcon = svgIconWrapper(SvgComponent);
